import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";

function useAddBeneficiary<T>(
  options?: MutationOptions<APIResponse<T>, APIError, Record<any, any>>
) {
  const {
    isLoading: addingBeneficiary,
    isError: isAddBeneficiaryError,
    error: addingBeneficiaryError,
    mutate: addBeneficiary,
  } = useMutation(
    async (variables: {
      account_number?: string;
      account_name?: string;
      bank_name?: string;
      visaro_username?: string;
      visaro_user: boolean;
    }) => {
      return await post(API_URL + "/account/banking/beneficiary", variables, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    },
    options
  );

  return {
    addBeneficiary,
    isAddBeneficiaryError,
    addingBeneficiaryError,
    addingBeneficiary,
  };
}

export default useAddBeneficiary;
